<template>
  <modal
    header-text=""
    button-text="Изменить"
    @action="$emit('setProfile')"
    @close="$emit('cancel')"
  >
    <div :class="$style.inputContainer">
      Вы уверены, что хотите изменить профиль?
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/settings-modal.vue';

export default {
  components: { Modal },
};
</script>

<style lang="scss" module>
.inputContainer {
  font-size: 13px;
  margin: 5px;
}
</style>
